import type { Metadata, Variants } from "types";
import { MetadataType } from "types";
import { useIsPbChecker } from "../../../providers/LivePbCheckProvider";
import LiveActivityFeedVirtualTableRowCell from "./LiveActivityFeedVirtualTableRowCell";
import MetadataHelpers from "helpers/MetadataHelpers";

function MetadataNameCell(props: {
  athleteId: string;
  exerciseId: string;
  metadata: Metadata | null;
  variant: Variants | null;
  defaultMetricValue: number | undefined;
  completedDate: string;
  measurementId: string;
}) {
  const exercise = props.metadata?.type === MetadataType.EXERCISE ? props.metadata.metadata : undefined;

  const isPb = useIsPbChecker({
    athleteId: props.athleteId,
    exerciseId: props.exerciseId,
    exercise,
    variant: props.variant,
    value: props.defaultMetricValue,
    date: props.completedDate,
    measurementId: props.measurementId,
  });

  return (
    <LiveActivityFeedVirtualTableRowCell
      align="left"
      label={MetadataHelpers.getMetadataCategory(props.metadata) || ""}
      // 🥇 🏆
      value={[MetadataHelpers.getMetadataName(props.metadata) || props.exerciseId, isPb && "🥇"]
        .filter(Boolean)
        .join(" ")}
    />
  );
}

export default MetadataNameCell;
